import {HttpParams} from '@angular/common/http';
import {IterableUtil} from '../collections/collection-utils';
import {AbstractControl, FormGroup} from '@angular/forms';
import {ParamMap, Params, RouterLink} from '@angular/router';

// https://angular.io/api/forms/FormControlStatus
export enum FormControlStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
  PENDING = 'PENDING'
}

//https://angular.io/api/router/Navigation#trigger
export enum NavigationTrigger {
  IMPERATIVE = 'imperative',
  POPSTATE = 'popstate',
  HASHCHANGE = 'hashchange'
}

export interface RouterLinkConfig {
  route: RouterLink['routerLink'];
  queryParams: RouterLink['queryParams'];
}

export function objectToHttpParams<T extends object>(requestObject: T): HttpParams | null {
  return requestObject == null
    ? null
    : IterableUtil.reduce(
      Object.entries(requestObject ?? <Record<string, never>>{}),
      (httpParams, [key, value]) => IterableUtil.isIterable(value)
        ? IterableUtil.reduce(value, (httpParams, valueItem) => httpParams.append(key, valueItem), httpParams)
        : httpParams.set(key, value),
      new HttpParams()
    );
}


// Stupid comparator function that stops the enormously dumb Angular behaviour of sorting keys when iterating over a map using
// the 'keyvalue' pipe. What's even better, is that Angular does not provide a comparator that can be used to disable the super stupid
// sorting behaviour so we need to create that comparator here
export function keepMapKeyValueOrder(_a: any, _b: any): number {
  return 0;
}

export type FormValues<T extends { [K in keyof T]: AbstractControl<any, any>; }> = ReturnType<FormGroup<T>['getRawValue']>;

export function updateQueryParam(searchParam: Array<any> | string | null, queryParamName: string, queryParams: Params): void {
  if (searchParam && searchParam.length) {
    queryParams[queryParamName] = searchParam;
  } else {
    delete queryParams[queryParamName];
  }
}

export function updateControlEnableState(control: AbstractControl, enableState: boolean): void {
  if (enableState) {
    if (!control.enabled) {
      control.enable({emitEvent: false});
    }
  } else if (!control.disabled) {
    control.disable({emitEvent: false});
  }
}

/** Run a task in a microtask, after the current change-detection pass. Mutating a value binding the current pass already
 * checked (e.g. [disabled]="!form.valid") synchronously throws NG0100 Expression-changed-after-checked; deferring the
 * mutation here avoids it. Useful when that binding lives in a parent component, already checked by the time a child reacts. */
export function deferTask(task: () => void): void {
  Promise.resolve().then(task);
}

export function readNumberArrayParam(queryParamMap: ParamMap, paramName: string): number[] | null {
  const values = queryParamMap.getAll(paramName);
  return values?.length ? values.map(Number) : null;
}